module.exports = __webpack_public_path__ + "img/测点_驱动主机.b4c0674f.png";